import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import CollectionViewer from '@/components/sections/MainPage/CollectionViewer';
import MainPage from '@/components/sections/MainPage/MainPage';

Vue.use(Router);
//console.log('location current path name', location.pathname);


export default new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: ``,
  routes: [
    {
      path: '/',
      name: 'mainpage',
      title: 'Samir Rehem',
      component: MainPage,
      index: 1
    },
    {
      path: '/presentation/:presentationId',
      name: 'presentation',
      title: 'Presentation',
      component: MainPage,
      index: 2
    },
    {
      path: '/presentation/:presentationId/collection/:id',
      name: 'presentation collection',
      title: 'Presentation Collection Viewer',
      component: MainPage,
      index: 3
    },
    {
      path: '/collection/:id',
      name: 'collection',
      title: 'Collection Viewer',
      component: MainPage,
      index: 4
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
